<template>
  <div
    v-show="hasOpenedAtleastOnce"
    class="dashboard-app--container"
  >
    <div v-if="!contentItems.length">
      <empty-state :title="$t('DASHBOARD_APPS.NO_DATA')" />
    </div>
    <template v-else>
      <div
        v-for="(contentItem, index) in contentItems"
        :key="index"
        class="dashboard-app--list"
      >
        <iframe
          v-if="isIframe(contentItem.url)"
          :id="`dashboard-app--frame-${index}`"
          title="dashboard-app"
          :src="contentItem.url"
          @load="() => onIframeLoad(index)"
        />
        <superset
          v-else
          :superset-id="contentItem.url"
          :url-params="supersetUrlParams"
        />
      </div>
    </template>
  </div>
</template>

<script>
import LoadingState from 'dashboard/components/widgets/LoadingState';
import Superset from './Superset.vue';
import EmptyState from 'dashboard/components/widgets/EmptyState';
import { mapGetters } from 'vuex';
export default {
  components: {
    LoadingState,
    EmptyState,
    Superset
  },
  props: {
    dashboardApp: {
      type: Object,
      required: true,
    },
    currentChat: {
      type: Object,
      default: null,
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hasOpenedAtleastOnce: false
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
    }),
    dashboardAppContext() {
      const context = { currentAgent: this.currentAgent };
      if (this.currentChat) {
        context.conversation = this.currentChat;
        context.contact = this.$store.getters['contacts/getContact'](this.contactId);
      }
      return context;
    },
    contactId() {
      return this.currentChat?.meta?.sender?.id;
    },
    currentAgent() {
      const { id, name, email } = this.$store.getters.getCurrentUser;
      return { id, name, email };
    },
    supersetUrlParams(){
      if(!this.currentChat){
        return {};
      }
      return {
        conversation_id: this.currentChat.display_id,
        contact_id: this.contactId
      };
    },
    contentItems() {
      const { content } = this.dashboardApp;
      const items = Array.isArray(content) ? content : [];
      return items.filter(item => item?.url);
    },
  },
  watch: {
    isVisible() {
      if (this.isVisible) {
        this.hasOpenedAtleastOnce = true;
      }
    },
  },

  mounted() {
    if (this.isVisible) {
      this.hasOpenedAtleastOnce = true;
    }

    window.onmessage = e => {
      if (
        typeof e.data !== 'string' ||
        e.data !== 'chatwoot-dashboard-app:fetch-info'
      ) {
        return;
      }
      this.onIframeLoad(0);
    };

    this.initialize();
  },
  methods: {
    isIframe(url) {
      try {
        new URL(url);
        return true;
      } catch (e) {
        return false;
      }
    },
    onIframeLoad(index) {
      const frameElement = document.getElementById(
        `dashboard-app--frame-${index}`
      );
      if (!frameElement) return;
      const eventData = { event: 'appContext', data: this.dashboardAppContext };
      frameElement.contentWindow.postMessage(JSON.stringify(eventData), '*');
    },
    initialize() {
    },
  },
};
</script>

<style>
.dashboard-app--container,
.dashboard-app--list {
  height: 100%;
  width: 100%;
}
.dashboard-app_loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}
.dashboard-app--container iframe {
  height: 100%;
  width: 100%;
  border: 0;
}
</style>
